<template>
  <div>
    <kk-breadcrumbs
      v-if="!isActualBiennale"
      :items="breadcrumbsItemsArchive"
      class="mb-5 mb-sm-10"
    />

    <page-title :title="pageData.fields.title" />

    <v-row class="section">
      <v-col
        v-for="(pressItem, index) in pageData.children"
        :key="index"
        cols="12"
        sm="6"
        lg="4"
        xl="3"
      >
        <press-item :item="pressItem.fields" />
      </v-col>
    </v-row>

    <zuruck with-aux-bar />
  </div>
</template>
<script>
import SimpleRepository from "@/api/simple.js";
import KkBreadcrumbs from "@/components/Article/KkBreadcrumbs.vue";
import PageTitle from "@/components/PageTitle.vue";
import Zuruck from "@/components/Zuruck.vue";
import PressItem from "@/components/PressItem.vue";

export default {
  components: {
    PressItem,
    KkBreadcrumbs,
    PageTitle,
    Zuruck,
  },
  props: {
    biennale: {
      type: String,
      required: true,
    },
  },
  metaInfo() {
    return {
      title: this.$store.getters.getWindowTitle(this.pageData.fields.title),
    };
  },
  data() {
    return {
      pageLoaded: false,
      pageData: {
        fields: {},
        main_fields: {},
        children: [],
      },
    };
  },
  computed: {
    isActualBiennale() {
      return this.biennale === this.$store.getters.getActualBiennaleIdent;
    },
    biennaleInfo() {
      return this.$store.getters.getBiennaleByIdent(this.biennale);
    },
    breadcrumbsItemsArchive() {
      const { biennale } = this;
      const biennaleName = this.biennaleInfo?.title || "";
      const biennaleNumber = this.biennaleInfo?.number || "";
      return [
        {
          text: this.pageData.main_fields.title || "",
          to: { name: "Main" },
          exact: true,
          disabled: false,
        },
        {
          text: this.pageData.main_fields.archive_title || "",
          to: { name: "ArchiveList" },
          exact: true,
          disabled: false,
        },
        {
          text: `${biennaleNumber} «${biennaleName}»`,
          to: { name: "ArchiveItem", params: { biennale } },
          exact: true,
          disabled: false,
        },
      ];
    },
  },
  watch: {
    "$store.getters.getLang"(newV, oldV) {
      if (oldV.length > 0) {
        this.loadPage();
      }
    },
    biennale() {
      this.loadPage();
    },
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    async loadPage() {
      const { data } = await SimpleRepository.getPress(this.biennale);
      this.pageData = data;
      this.$store.commit("setLangsAvail", data.published);
      this.pageLoaded = true;
      this.$emit("page-loaded");
    },
  },
};
</script>
